import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const images = [
  {
    src: "/renamed_website_images/smart-classroom-session-2.jpg",
    heading: "Vibrant Learning",
    text: "Students engaged in interactive classroom activities and collaborative projects.",
  },
  {
    src: "/renamed_website_images/music-guitar-class-1.jpg",
    heading: "Creative Expressions",
    text: "Nurturing the artistic, musical, and performing talents of our students.",
  },
  {
    src: "/renamed_website_images/sports-activities-kabaddi-2.jpg",
    heading: "Sports Activities",
    text: "Fostering athletic excellence, sportsmanship, and physical health.",
  },
  {
    src: "/renamed_website_images/computer-lab-1.jpg",
    heading: "Tech-Enabled Education",
    text: "Modern computer labs preparing students with essential digital skills.",
  },
  {
    src: "/renamed_website_images/events-001.jpg",
    heading: "Community Spirit",
    text: "Celebrating cultural festivals, annual events, and school unity together.",
  },
  {
    src: "/renamed_website_images/library-reading-1.jpg",
    heading: "Academic Excellence",
    text: "Dedicated library study and rigorous ICSE curriculum achievement.",
  },
];

const Glance = () => {
  return (
    <>
      {/* ── Image Grid Section ── */}
      <section className="relative py-24 px-6 md:px-16 overflow-hidden bg-[#020810]">
        {/* Background Decor */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" />

        <div className="max-w-7xl mx-auto relative z-10">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-20"
          >
            <span className="section-badge mb-6">Visual Journey</span>
            <h2
              className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              Life at <span className="text-shimmer">Galaxy Star</span>
            </h2>
            <div className="w-24 h-1 bg-gold/50 mx-auto rounded-full" />
          </motion.div>

          {/* Image grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {images.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                viewport={{ once: true }}
                className="group relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5] md:aspect-square"
              >
                <img
                  src={item.src}
                  alt={item.heading}
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.02]"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#020810] via-transparent to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" />

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-8 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <h3
                    className="text-xl font-bold text-gold mb-2 uppercase tracking-widest"
                    style={{ fontFamily: "Orbitron, sans-serif" }}
                  >
                    {item.heading}
                  </h3>
                  <p className="text-gray-300 text-sm leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                    {item.text}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* View More Button */}
          <div className="mt-16 text-center">
            <Link
              to="/gallery"
              className="cosmic-btn-outline px-12 py-4 rounded-full text-sm uppercase tracking-widest hover:bg-white/10 transition-all"
            >
              View Full Gallery
            </Link>
          </div>
        </div>
      </section>

      {/* ── YouTube Section ── */}
      <section className="relative py-24 px-6 overflow-hidden bg-[#040b1f]">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="mb-14"
          >
            <span className="section-badge mb-6">Experience Galaxy</span>
            <h2
              className="text-4xl font-black text-white mb-4"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              Our School <span className="text-gold">Story</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="max-w-5xl mx-auto"
          >
            <div className="relative p-2 bg-white/5 rounded-[2rem] border border-white/10 shadow-2xl overflow-hidden aspect-video">
              <iframe
                src="https://www.youtube.com/embed/7Rgi1S6mcug?si=VPhp7ZgeC4DDDEeP"
                title="Galaxy Star Public School"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full rounded-[1.8rem]"
              />
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Glance;
